import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule, MatProgressSpinnerModule, MatRadioModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ArchiveEnvironmentDialogComponent } from './archive-environment-dialog.component';
import { ArchiveEnvironmentDialogService } from './archive-environment-dialog.service';
import { ArchiveLocationEnvironmentApi } from './archive-location-environment.api';

@NgModule({
  declarations: [
    ArchiveEnvironmentDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    TranslateModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  entryComponents: [
    ArchiveEnvironmentDialogComponent
  ],
  providers: [
    ArchiveEnvironmentDialogService,
    ArchiveLocationEnvironmentApi
  ]
})
export class ArchiveEnvironmentDialogModule {}
